import _ from 'lodash';

export function preload(props, force) {
    const { medals, medalsActions, upcoming, tournamentActions, alumnis, alumniActions } = props;
    (!medals || !medals.length || force) && medalsActions && medalsActions.fetchFull();
    (!upcoming || !upcoming.length || force) && tournamentActions && tournamentActions.fetchUpcoming();
    (!alumnis || !alumnis.length || force) && alumniActions && alumniActions.fetch();
    
}

export function formatPrice(cents) {
    return `$${(cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
}

export function formatPriceInt(cents) {
    return `$${(cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
}

export function formatPriceWithoutCurrency(cents) {
    return `${(cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
}

export function rando(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}

export function validateEmail(email) {

    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());

}

export function getFunName() {
    const adjectives = ['adorable', 'beautiful', 'clean', 'drab', 'elegant', 'fancy', 'glamorous', 'handsome', 'long', 'magnificent', 'old-fashioned', 'plain', 'quaint', 'sparkling', 'ugliest', 'unsightly', 'angry', 'bewildered', 'clumsy', 'defeated', 'embarrassed', 'fierce', 'grumpy', 'helpless', 'itchy', 'jealous', 'lazy', 'mysterious', 'nervous', 'obnoxious', 'panicky', 'repulsive', 'scary', 'thoughtless', 'uptight', 'worried'];

    const nouns = ['women', 'men', 'children', 'teeth', 'feet', 'people', 'leaves', 'mice', 'geese', 'halves', 'knives', 'wives', 'lives', 'elves', 'loaves', 'potatoes', 'tomatoes', 'cacti', 'foci', 'fungi', 'nuclei', 'syllabuses', 'analyses', 'diagnoses', 'oases', 'theses', 'crises', 'phenomena', 'criteria', 'data'];

    return `${rando(adjectives)}-${rando(adjectives)}-${rando(nouns)}`;
}

export function calculateBWContrast(hex, bw) {
    if (hex.indexOf('#') === 0) {
        hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        throw new Error('Invalid HEX color.');
    }
    var r = parseInt(hex.slice(0, 2), 16),
        g = parseInt(hex.slice(2, 4), 16),
        b = parseInt(hex.slice(4, 6), 16);

    var o = Math.round(((r * 299) +
        (g * 587) +
        (b * 114)) / 1000);

    return o > 125
        ? '#000000'
        : '#FFFFFF';
}

export function calculateBWContrastClass(hex) {
    if (hex.indexOf('#') === 0) {
        hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        throw new Error('Invalid HEX color.');
    }
    var r = parseInt(hex.slice(0, 2), 16),
        g = parseInt(hex.slice(2, 4), 16),
        b = parseInt(hex.slice(4, 6), 16);

    var o = Math.round(((r * 299) +
        (g * 587) +
        (b * 114)) / 1000);

    return o > 125
        ? 'black'
        : 'white';
}

export const ItemTypes = {
    DIVISION: 'division',
    TEAM: 'team',
    FLIGHT: 'flight',
    FLIGHTEDTEAMS: 'flightedTeam',
    GAMEDAYRULE: 'gamedayrule',
    EXCEPTIONRULE: 'exceptionrule',
    FIELDAVAILABILITYRULE: 'fieldavailabilityrule',
    BRACKETPLACEMENT: 'bracketplacement',
    ROSTEREDPLAYER: 'rosteredplayer',
    NONROSTEREDPLAYER: 'nonrosteredplayer',
    REGISTRATIONFEE: 'registrationfee',
    TRYOUT: 'tryout',
    ADJUSTMENT: 'adjustment',
    ZIPCODE: 'zipcode',
    FAMILYADJUSTMENT: 'family_adjustment',
    FREETEXT: '2',
    SINGLESELECTION: 'single_selection',
    MULTIPLESELECTION: 'multiple_selection',
    RADIO: '6',
    CHECK: '3',
    CHECKLIST: '4',
    SELECT: '5',
    QANDA: 'q_and_a',
    QUESTIONGROUP: 'question_group',
    ROSTERLOCK: 'roster_lock',
    APPLIEDQUESTION: 'applied_question'
};

export function generateRandomId(x) {
    const data = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'A', 'B', 'C', 'D', 'E', 'F'];
    return ("ID-" + _.sampleSize(data, x).join(''));
}

export function detectCreditCardType(number) {
    // visa
    var re = new RegExp("^4");
    if (number.match(re) != null)
        return {
            IdPaymentMethod: 10,
            Name: "Visa",
            Image: "/images/icon/visa-white.png"
        };

    // Mastercard 
    // Updated for Mastercard 2017 BINs expansion
    if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(number))
        return {
            IdPaymentMethod: 20,
            Name: "Mastercard",
            Image: "/images/icon/mastercard-white.png"
        };

    // AMEX
    re = new RegExp("^3[47]");
    if (number.match(re) != null)
        return {
            IdPaymentMethod: 30,
            Name: "Amex",
            Image: "/images/icon/card-white.png"
        };

    // Discover
    re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
    if (number.match(re) != null)
        return {
            IdPaymentMethod: 40,
            Name: "Discover",
            Image: "/images/icon/card-white.png"
        };

    return {
        Image: "/images/icon/card-white.png"
    };
}

export function toTitleCase(str) {

    return str.replace(
        /\w\S*/g,
        function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
    );

}

export function getOrdinal(i) {
    var j = i % 10,
        k = i % 100;
    if (j === 1 && k !== 11) {
        return i + "st";
    }
    if (j === 2 && k !== 12) {
        return i + "nd";
    }
    if (j === 3 && k !== 13) {
        return i + "rd";
    }
    return i + "th";
}

export function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export function log(args) {
    _.keys(args).forEach(key => {
        console.log('')
        console.log('')
        console.log(`------- ${key.toUpperCase().split('').join(' ')} -------`)
        console.log(args[key])
        console.log('-------')
        console.log('')
        console.log('')
    });
}



// WEBPACK FOOTER //
// ./src/helpers.js